"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var errorHandler_1 = require("../../../../common/service/errorHandler");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var errorMessageHoc_1 = require("../../../../common/components/presentation/Error/errorMessageHoc");
var WebpayContainer_1 = require("./paymentProviders/webpay/WebpayContainer");
var Payment2C2PContainer_1 = require("./paymentProviders/2c2p/Payment2C2PContainer");
var PaymentVisaNet_1 = require("./paymentProviders/visanet/PaymentVisaNet");
var PaymentEwayContainer_1 = require("./paymentProviders/eway/PaymentEwayContainer");
var paymentType_1 = require("../../../common/constants/paymentType");
var MercadoPagoContainer_1 = require("./paymentProviders/mercadopago/MercadoPagoContainer");
var StripeContainer_1 = require("./paymentProviders/stripe/StripeContainer");
var Payment = function (_a) {
    var _b;
    var goToNextStep = _a.goToNextStep, deal = _a.deal, loading = _a.loading;
    var parentNodeId = react_1.useState('wrapper:checkout:paymentProvider')[0];
    var paymentProvider = usePlatformConfig_1.default().platformConfig.paymentProvider;
    var paymentProviderMap = (_b = {},
        _b[paymentType_1.default.WEBPAY] = <WebpayContainer_1.default deal={deal}/>,
        _b[paymentType_1.default['2C2P']] = <Payment2C2PContainer_1.default goToNextStep={goToNextStep} deal={deal} loading={loading}/>,
        _b[paymentType_1.default.VISANET] = <PaymentVisaNet_1.default deal={deal}/>,
        _b[paymentType_1.default.EWAY] = <PaymentEwayContainer_1.default />,
        _b[paymentType_1.default.MERCADOPAGO] = <MercadoPagoContainer_1.default goToNextStep={goToNextStep} deal={deal} loading={loading}/>,
        _b[paymentType_1.default.STRIPE] = <StripeContainer_1.default deal={deal}/>,
        _b);
    var selectedProvider = paymentProviderMap[paymentProvider];
    if (!selectedProvider) {
        errorHandler_1.default.handleError("No payment provider was selected. [" + parentNodeId + "]");
        return <div data-test="payment_page:no_payment_provider">There is no payment provider</div>;
    }
    return selectedProvider;
};
exports.default = errorMessageHoc_1.default(Payment);
